export default __webpack_public_path__ + "static/media/cart-icon.a20d74f8.svg";